import Styled from 'styled-components'
import LockIcon from '../../assets/lock-banner.png'

const StyledBannerMFAPreLoginFiveThousand = Styled.div`
    margin: 60px auto;
    font-size: 24px;
    letter-spacing: -0.7px;
    line-height: 28px;
    border-radius: 20px;
    background-color: rgba(7, 78, 232, 1);
    color: ${({ theme }) => theme.colors.white};
    font-weight: 600;
    display: flex;
    padding: 10px 20px;
    max-width: 1200px;
    font-family: 'Lato', sans-serif;


   
    img {
        max-height: 50px;
        margin-right: 10px;
        margin-top: 10px;
        transform: translateY(70%);
        @media (min-width: ${({ theme }) =>
          theme.breakPoints.xSmall}) {
          max-height: 78px;
        }
    }

  @media (max-width: ${({ theme }) => theme.breakPoints.small}) {
    margin: 32px 8px 32px;
    font-size: 20px;
    line-height: 24px;
  }
`

// BannerMFAPreLoginFiveThousand will show before end 2025, and be removed after January 1st, 2026
const shouldShowBanner = () => {
  const currentDate = new Date()
  const endDate = new Date(2026, 0, 1) // January 1st, 2026 (months are 0-indexed)
  return currentDate < endDate
}

const BannerMFAPreLoginFiveThousand = () => {
  if (!shouldShowBanner()) return null
  return (
    <StyledBannerMFAPreLoginFiveThousand>
      <img src={LockIcon} alt="equal housing opportunity logo" />

      <div>
        <p>
          Coming soon! We are upgrading our security measures in order
          to better protect your account. All reversedepartment.com
          account holders will be required to enroll in Multi-Factor
          Authentication (MFA) by 12/31/2025. If you have already
          enrolled in MFA, there is nothing more for you to do.
        </p>
        <br />
        <p>
          If you would like to beat the rush, you can go to the My
          Account screen after you login and choose “Enable MFA.”
        </p>
      </div>
    </StyledBannerMFAPreLoginFiveThousand>
  )
}

export default BannerMFAPreLoginFiveThousand
